import React, { useEffect, useState } from "react";
import Cookies from "js-cookie";
import { Link } from "react-router-dom";
import { bidangDummy } from "../../../types/dataBidang";
import DataLogo from "../DataLogo/dataLogo";
import Navbar from "../../Components/Navbar";
import FooterTwo from "../../Components/Footer/footherTwo";

interface Presiden {
  id: number;
  nama: string;
  jabatan: string;
  bidang: string;
  foto: string;
}

const PageUtama: React.FC = () => {
  const [data, setData] = useState<Presiden[]>([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState("");
  const [selectedBidang, setSelectedBidang] = useState<string>("");
  const [openDropdown, setOpenDropdown] = useState(false);

  const handleSelect = (value: string) => {
    setSelectedBidang(value);
    setOpenDropdown(false); // tutup dropdown setelah pilih
  };

  const fetchData = async (query: string = "", bidang?: string) => {
    try {
      const token = Cookies.get("token");
      const params = new URLSearchParams();

      if (query) params.append("search", query);

      // bidang default
      params.append("bidang[]", "Presiden & Wakil Presiden Republik Indonesia");

      // bidang tambahan dari user
      if (bidang) {
        params.append("bidang[]", bidang);
      }

      const url = `${process.env.REACT_APP_API_BASE_URL}/api/presiden` + (params.toString() ? `?${params.toString()}` : "");

      const res = await fetch(url, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });

      if (!res.ok) {
        throw new Error("Gagal ambil data presiden");
      }

      const result = await res.json();
      const items = Array.isArray(result) ? result : result.data ?? [];
      setData(items as Presiden[]);
    } catch (err) {
      console.error(err);
      setData([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData("", selectedBidang || undefined);
  }, []);

  useEffect(() => {
    const delay = setTimeout(() => {
      fetchData(search, selectedBidang);
    }, 500);
    return () => clearTimeout(delay);
  }, [search, selectedBidang]);

  // Group by bidang
  const groupedData = data.reduce((acc: Record<string, Presiden[]>, item) => {
    if (!acc[item.bidang]) {
      acc[item.bidang] = [];
    }
    acc[item.bidang].push(item);
    return acc;
  }, {});

  if (loading) {
    return (
      <div className="flex justify-center items-center h-40">
        <div className="animate-spin rounded-full h-12 w-12 border-t-4 border-primary"></div>
      </div>
    );
  }

  return (
    <>
      <Navbar />

      <div className="min-h-screen px-6 pb-6 pt-24 bg-gradient-to-r from-white via-yellow-50 to-yellow-100">
        <div className="mt-2 mb-5 flex justify-center">
          <img src="/images/pancasila.png" alt="" className="w-20 h-24" />
        </div>

        {/* Presiden & Wakil Presiden */}
        {groupedData["Presiden & Wakil Presiden Republik Indonesia"] && (
          <div className="mb-12 ">
            <h2 className="text-2xl max-sm:text-xl font-semibold text-yellow-800 mb-6 border-b-2 border-yellow-400 text-center pb-2">Sistem Pengawasan Pejabat Publik Republik Indonesia</h2>
            <div className="flex gap-3 justify-center max-sm:grid grid-cols-2">
              {groupedData["Presiden & Wakil Presiden Republik Indonesia"].map((item) => (
                <Link key={item.id} to={`/detailPageUtama/${item.id}`} className="bg-white rounded-2xl shadow-md hover:shadow-xl transition-shadow duration-300 p-3 flex flex-col items-center border border-yellow-200">
                  <div className="max-sm:w-[135px] w-36 h-48 overflow-hidden rounded-xl border-2 border-yellow-400 shadow">
                    <img src={item.foto} alt={item.nama} className="w-full h-full object-cover transform hover:scale-105 transition-transform duration-300" />
                  </div>
                  <h3 className="mt-4 text-lg font-semibold text-gray-800 text-center max-sm:text-sm">{item.nama}</h3>
                  <p className="text-sm max-sm:text-xs text-gray-600 text-center">{item.jabatan}</p>
                </Link>
              ))}
            </div>
            <h2 className="text-xl max-sm:text-base mt-4 font-semibold text-yellow-800 mb-6  text-center pb-2">Presiden & Wakil Presiden Republik Indonesia</h2>
          </div>
        )}

        {/* Dropdown bidang lain */}
        {/* <div className="w-full flex justify-center mb-6">
        <div className="relative w-full max-w-md">
          <button onClick={() => setOpenDropdown(!openDropdown)} className="w-full flex justify-center items-center p-3 rounded-xl border border-yellow-400 shadow focus:outline-none focus:ring-2 focus:ring-yellow-500 bg-white">
            {selectedBidang || "-- Pilih Bidang Kementerian --"}
          </button>

          {openDropdown && (
            <ul className="absolute z-10 mt-2 w-full bg-white border border-yellow-300 rounded-xl shadow-lg max-h-60 overflow-y-auto">
              {bidangDummy.map((bidang) => (
                <li key={bidang.id} onClick={() => handleSelect(bidang.nama)} className={`p-3 cursor-pointer ${selectedBidang.includes(bidang.nama) ? "bg-yellow-200" : "hover:bg-yellow-100"}`}>
                  {bidang.nama}
                </li>
              ))}
            </ul>
          )}
        </div>
      </div> */}

        {/* Bidang tambahan yang dipilih */}
        {selectedBidang && groupedData[selectedBidang] && (
          <div className="mb-12">
            <h2 className="text-2xl max-sm:text-xl font-semibold text-yellow-800 mb-6 border-b-2 border-yellow-400 text-center">{selectedBidang}</h2>
            <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3">
              {groupedData[selectedBidang].map((item) => (
                <Link key={item.id} to={`/detailPageUtama/${item.id}`} className="bg-white rounded-2xl shadow-md hover:shadow-xl transition-shadow duration-300 p-3 flex flex-col items-center border border-yellow-200">
                  <div className="max-sm:w-[135px] w-36 h-48 overflow-hidden rounded-xl border-2 border-yellow-400 shadow">
                    <img src={item.foto} alt={item.nama} className="w-full h-full object-cover transform hover:scale-105 transition-transform duration-300" />
                  </div>
                  <h3 className="mt-4 text-lg font-semibold text-gray-800 text-center max-sm:text-sm">{item.nama}</h3>
                  <p className="text-sm max-sm:text-xs text-gray-600 text-center">{item.jabatan}</p>
                </Link>
              ))}
            </div>
          </div>
        )}

        {!selectedBidang && <DataLogo />}
      </div>
      <FooterTwo />
    </>
  );
};

export default PageUtama;
